import { createRouter, createWebHistory } from "vue-router";
import { registerNavigation } from "@/shared/api/navigation";
import { routes } from "./routes";
import handleRole from "./guard";
import "./types";

function getRouter() {
  const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to) {
      if (to.hash) return { el: to.hash, top: 80, behavior: "smooth" };
      return { top: 0, behavior: "smooth" };
    },
    routes,
  });
  router.beforeEach(handleRole);
  registerNavigation({
    push: (path) => router.push(path),
    currentPath: () => router.currentRoute.value.path,
  });
  return router;
}

export default getRouter();
